export { default as aggregatingRatingSchema } from './aggregate-rating';
export { default as breadcrumbSchema } from './breadcrumb';
export { default as faqSchema } from './faq';
export { default as offerSchema } from './offer';
export { default as productSchema } from './product';
export { default as reviewSchema } from './review';